export abstract class Constants {
	public static readonly BrokerReportGridBuildRowLinkTemplateFunction = "onBrokerReportGridBuildRowLinkTemplate";
	public static readonly CssClassFinancial = "financial";
	public static readonly DataKeyCurrentBroker = "CurrentBroker";
	public static readonly DataKeyMessages = "Messages";
	public static readonly DataKeyPrompt = "Prompt";
	public static readonly EqualityRuleName = "Equality";
	public static readonly ExportQueryFieldName = "ExportQuery";
	public static readonly HasNumericValueRuleName = "HasNumericValue";
	public static readonly LoaderSilentDisable = "silent-disable";
	public static readonly LoanStatusBuildRowLinkTemplateFunction = "onLoanStatusBuildRowLinkTemplate";
	public static readonly LoanStatusBuildRowLinkTemplateHandler = "IPF.handlers.onLoanStatusBuildRowLinkTemplate";
	public static readonly LogoutPageName = "/Identity/Account/Logout";
	public static readonly MinLoanAmount = 20;
	public static readonly NegativeValueRuleName = "NegativeValue";
	public static readonly NewBusinessFormId = "new-business";		
	public static readonly PositiveValueRuleName = "PositiveValue";
	public static readonly TierKeyPageTier = "PageTier";
}